import { Module, StatusPanelDef } from '@ag-grid-community/core'
import { EnterpriseCoreModule } from '@ag-grid-enterprise/core'
import { StatusBarModule } from '@ag-grid-enterprise/status-bar'
import { SelectedRowsStatusBarComp } from '@helios/generic-components'

export const multiBreaksStatusBarModuleName = 'hsMultiBreaksStatusBarModule'
export const selectedRowsStatusBar = 'hsMultiBreaksSelectedRowsStatusBar'

export const multiBreaksStatusBarPanel: { statusPanels: StatusPanelDef[] } = {
  statusPanels: [
    {
      statusPanel: selectedRowsStatusBar,
      align: 'left',
    },
    {
      statusPanel: 'agTotalAndFilteredRowCountComponent',
      align: 'center',
    },
  ],
}

export const MultiBreaksStatusBarModule: Module = {
  moduleName: multiBreaksStatusBarModuleName,
  userComponents: [
    {
      componentName: selectedRowsStatusBar,
      componentClass: SelectedRowsStatusBarComp,
    },
  ],
  dependantModules: [StatusBarModule, EnterpriseCoreModule],
}
